import React, { Component } from 'react';
import classnames from 'classnames';
import { ImageProps } from 'components/Image/props';

import ImageComponent from './ImageComponent';

export default class ImageContainer extends Component<ImageProps> {
  static displayName = 'ImageContainer';

  render() {
    const {
      border,
      borderContainerClassName,
    } = this.props;

    if (!border) {
      return <ImageComponent {...this.props} />;
    }

    return (
      <div
        className={classnames(
          getBorderClasses(border),
          borderContainerClassName,
        )}
      >
        <ImageComponent {...this.props} />
      </div>
    );
  }
}

function getBorderClasses(border: Pick<ImageProps, 'border'>) {
  return classnames({
    'card-border': border,
    'card-gold': border === 'gold',
    'card-silver': border === 'silver',
    'card-bronze': border === 'bronze',
    'card-black': border === 'black',
    'card-red': border === 'red',
    'card-purple': border === 'purple',
  });
}
